// Utils
import { getFrom } from 'ezyvet-fe-helpers';
import { createObjectPaths } from '../../objectIdentity';
/**
 * Using the given set of values, builds and returns an object id to object map,
 *
 * @param {Identifiable<T>} values
 *
 * @return {ObjectMap}
 */
export var getObjectIdToObjectMap = function (values) {
    var map = {};
    var objectIdsToPathMap = createObjectPaths(values);
    Object.keys(objectIdsToPathMap).forEach(function (objectId) {
        map[objectId] = getFrom(values, objectIdsToPathMap[objectId]);
    });
    return map;
};
//# sourceMappingURL=getObjectIdToObjectMap.js.map